var $ = require('jquery');

$(function () {

    $('.featured-elements__carousel').slick({
        arrows: true,
        centerMode: true,
        centerPadding: '30px',
        mobileFirst: true,
        responsive: [{
            breakpoint: 767,
            settings: {
                autoplay: true,
                autoplaySpeed: 5000,
                centerMode: false,
                centerPadding: '0'
            }
        }],
        rtl: window.GenericUtilities.isRTL()
    });
    // to get slick slider to initialize on screen resize
    // https://github.com/kenwheeler/slick/issues/1730
    $(window).on('resize orientationchange', function () {
        $('.featured-elements__carousel').slick('resize');
    });
});
